export default {"src":"/_next/static/media/ecto-hub.224dcd81.svg","height":38,"width":230,"blurWidth":0,"blurHeight":0};